import './ccf-textfield.module.scss';
import { TextField, TextFieldProps } from '@mui/material';

interface CcfCustomTextFieldProps {
  id: string;
}

export type CcfTextFieldProps = TextFieldProps & CcfCustomTextFieldProps;

/**
 * CcfTextField used to display react text input
 * @param param - CcfTextField
 * @example <CcfTextField />
 */
export function CcfTextField({ ...rest }: CcfTextFieldProps) {
  return (
    <TextField
      sx={{
        '& .MuiOutlinedInput-root': {
          '& > fieldset': { border: '1px solid #c4c4c4', },
          '&.Mui-disabled': { border: '1px solid #c4c4c4' },
        },
      }}
      type={'text' || rest.type}
      {...rest}
    ></TextField>
  );
}

export default CcfTextFieldProps;
